var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TimeSpentByActivityType } from '@web/components/Dashboard/TimeSpentOnWorkActivities/TimeSpentByActivityType';
import TimeSpentOnWorkActivities from '@web/components/Dashboard/TimeSpentOnWorkActivities/TimeSpentOnWorkActivities';
import Loading from '@web/components/layout/Loading';
import { trpc } from '@web/lib/trpc';
import { useFilters } from '@web/utility/hooks/useFilters';
import { getInterval } from '@workalizer/shared/utils';
export var TimeSpentOnWorkActivitiesSection = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.includeUserFilter, includeUserFilter = _c === void 0 ? false : _c, _d = _b.userId, userIdProp = _d === void 0 ? null : _d, _e = _b.orgUnitId, orgUnitIdProp = _e === void 0 ? null : _e, _f = _b.useEventsLogNavigation, useEventsLogNavigation = _f === void 0 ? false : _f;
    var _g = useFilters(), dateFrom = _g.dateFrom, dateTo = _g.dateTo, orgUnit = _g.orgUnit, user = _g.user;
    var interval = getInterval(dateFrom, dateTo);
    var userId = includeUserFilter ? (userIdProp !== null && userIdProp !== void 0 ? userIdProp : user) : null;
    var orgUnitId = includeUserFilter ? (orgUnitIdProp !== null && orgUnitIdProp !== void 0 ? orgUnitIdProp : orgUnit) : orgUnit;
    var _h = trpc.timeSpentOnWorkActivities.useQuery(__assign(__assign({ dateFrom: dateFrom, dateTo: dateTo, orgUnitId: orgUnitId }, (userId ? { userId: userId } : {})), { groupBy: interval })), data = _h.data, isLoading = _h.isLoading, refetch = _h.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var refetchWidgets = function () {
        void refetch();
    };
    return (_jsxs("div", __assign({ className: "flex w-full flex-col gap-12" }, { children: [_jsx(TimeSpentOnWorkActivities, { data: data.current, previousData: data.previous, teamAverage: data.teamAverage, userId: userId, orgUnitId: orgUnitId, interval: interval, dateFrom: dateFrom, dateTo: dateTo, refetch: refetchWidgets }), _jsx(TimeSpentByActivityType, { data: data.current, previousData: data.previous, teamAverageByType: data.teamAverageByType, userId: userId, orgUnitId: orgUnitId, interval: interval, dateFrom: dateFrom, dateTo: dateTo, refetch: refetchWidgets, useEventsLogNavigation: useEventsLogNavigation })] })));
};
